module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='url:<input type=\'text\' class=\'field\' id=\'url\' value=\''+
((__t=(url))==null?'':__t)+
'\'>\n';
}
return __p;
};
